import Vue from "vue";
import Router from "vue-router";

import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";

import Home from "./views/home/home-form";
import Profile from "./views/worker/worker-profile/profile";
import DisplayData from "./views/display-data";
import BizContactList from './views/contact/biz-contact/biz-contact-list-form';
import BizContactDetail from './views/contact/biz-contact/biz-contact-detail-form';
import ShiftAdjustment from './views/shift/shift-adjustment/shift-adjustment-form';
import OfficeShiftChangeJob from './views/shift/shift-adjustment/office-shift-change-job-form';
import WorkerShiftChange from './views/shift/shift-adjustment/worker-shift-change-form';
import WorkerTimeSheet from './views/shift/shift-adjustment/worker-time-sheet-form';
import ChangePassword from './views/auth/change-password/change-password-form';
import DefaultPlacementList from './views/placement/defaultPlacement/default-placement-list-form';
import SelectLocation from './views/auth/select-location/select-location-form';

Vue.use(Router);

const router = new Router({
  base: '/jc/',
  mode: 'history',
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "*",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "home",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Home
      }
    },
    {
      path: "/login-form",
      name: "login-form",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        // route level code-splitting
        // this generates a separate chunk (login.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        content: () =>
          import(/* webpackChunkName: "login" */ "./views/auth/login/login-form")
      }
    },
    {
      path: "/select-location",
      name: "select-location",
      meta: { requiresAuth: true },
      components: {
        layout: simpleLayout,
        content: SelectLocation
      }
    },
    {
      path: "/change-location",
      name: "change-location",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: SelectLocation
      }
    },
    {
      path: "/change-password-form",
      name: "change-password-form",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: ChangePassword
      }
    },
    {
      path: "/forgot-password-form",
      name: "forgot-password-form",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        // route level code-splitting
        // this generates a separate chunk (forgot-password.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        content: () =>
          import(/* webpackChunkName: "forgot-password" */ "./views/auth/forgot-password/forgot-password-form")
      }
    },
    {
      path: "/reset-password-form/:mailAddress/:token",
      name: "reset-password-form",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        // route level code-splitting
        // this generates a separate chunk (reset-password.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        content: () =>
          import(/* webpackChunkName: "reset-password" */ "./views/auth/reset-password/reset-password-form")
      }
    },
    {
      path: "/profile",
      name: "profile",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Profile
      }
    },
    {
      path: "/display-data",
      name: "display-data",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: DisplayData
      }
    },
    {
      path: "/default-placement-list",
      name: "default-placement-list",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: DefaultPlacementList
      },
    },
    {
      path: "/biz-contact-list",
      name: "biz-contact-list",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: BizContactList
      }
    },
    {
      path: "/biz-contact-detail/:bizcontactid",
      name: "biz-contact-detail",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: BizContactDetail
      }
    },
    {
      path: "/shift-adjustment",
      name: "shift-adjustment",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: ShiftAdjustment
      }
    },
    {
      path: "/office-shift-change-job/:workingDay",
      name: "office-shift-change-job",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: OfficeShiftChangeJob
      }
    },
    {
      path: "/worker-shift-change/:workingDay",
      name: "worker-shift-change",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: WorkerShiftChange
      }
    },
    {
      path: "/worker-time-sheet/:workingDay",
      name: "worker-time-sheet",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: WorkerTimeSheet
      }
    },
    {
      path: "/worker",
      name: "worker",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Worker
      }
    }]
});

router.beforeEach((to, from, next) => {

  //从sessionStorage中读取store
  if (router.app.$options.store.state.logFlag != "logout") {
    if (router.app.$options.store.state.token == "") {
      if (sessionStorage.getItem("store")) {

        router.app.$options.store.replaceState(
          Object.assign({}, router.app.$options.store.state, JSON.parse(sessionStorage.getItem("store"))))
      }
    }
  }

  let token = router.app.$options.store.state.token

  if (to.matched.some(record => record.meta.requiresAuth)) {

    if (token == "") {
      next({
        name: "login-form",
        query: { redirect: to.fullPath }
      });
    } else {

      if (from.name != "login-form") {
        router.app.$options.store.commit(
          {
            type: 'setFromUrlName',
            fromUrlName: from.name,
          })
      }

      next();
    }
  } else {

    if (to.name === "login-form" && token != "") {
      if (router.app.$options.store.state.currentLocation.locationId != undefined) {
        next({ name: "home" });
      } else {
        router.app.$options.store.commit({
          type: 'logout',
        })
      }
    }

    next();
  }
});

export default router;
